export default __webpack_public_path__ + "static/media/roboto-v27-latin-500.86988841.woff2";